<template>
    <div class="date-picker">
      <label v-if="label">{{ label }}</label>
      <input
        type="date"
        :value="internalValue"
        @input="updateValue($event.target.value)"
      />
    </div>
  </template>
  
  <script>
  export default {
    props: {
      value: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      }
    },
    computed: {
      internalValue: {
        get() {
          // Convert value from DD/MM/YYYY to YYYY-MM-DD for the input element
          return this.value ? this.formatToDMY(this.value) : '';
        },
        set(newValue) {
          // Emit value as DD/MM/YYYY to the parent component
          this.$emit('input', this.formatToDisplay(newValue));
        }
      }
    },
    data() {
      return {
        
      }
    },
    methods: {
      updateValue(value) {
        // Directly update the internalValue to trigger the computed setter
        this.internalValue = value;
      },
      formatToDMY(date) {
        const [day, month, year] = date.split('-');
        if (day && month && year) {
          return `${day}-${month}-${year}`;
        }
        return date;
      },
      formatToDisplay(date) {
        const [year, month, day] = date.split('-');
        if (year && month && day) {
          return `${day}-${month}-${year}`;
        }
        return date;
      }
    }
  };
  </script>
  
  <style scoped>
  .date-picker {
    display: flex;
    flex-direction: column;
  }
  .date-picker label {
    margin-bottom: 4px;
  }
  .date-picker input {
    padding: 4px;
    font-size: 16px;
  }
  </style>
  